import Vue from 'vue';

export const CleanupMixin = Vue.extend({
    beforeCreate() {
        (this as any)._cleanupHandlers = [];
    },

    beforeDestroy() {
        const componentName = (this as any).$options.name || 'composant';
        const handlers = (this as any)._cleanupHandlers || [];
        handlers.forEach((cleanup: () => void) => {
            try {
                cleanup();
            } catch (error) {
                console.error('[CleanupMixin] Erreur cleanup:', error);
            }
        });

        (this as any)._cleanupHandlers = [];
    },

    methods: {
        $onCleanup(handler: () => void) {
            if (!(this as any)._cleanupHandlers) {
                (this as any)._cleanupHandlers = [];
            }
            (this as any)._cleanupHandlers.push(handler);
        },

        $addListener(
            target: EventTarget,
            event: string,
            handler: EventListener,
            options?: boolean | AddEventListenerOptions
        ) {
            target.addEventListener(event, handler, options);
            this.$onCleanup(() => {
                target.removeEventListener(event, handler, options);
            });
        },

        $setInterval(handler: TimerHandler, timeout?: number, ...args: any[]): number {
            const id = window.setInterval(handler, timeout, ...args);
            this.$onCleanup(() => clearInterval(id));
            return id;
        },

        $setTimeout(handler: TimerHandler, timeout?: number, ...args: any[]): number {
            const id = window.setTimeout(handler, timeout, ...args);
            this.$onCleanup(() => clearTimeout(id));
            return id;
        },

        $requestAnimationFrame(callback: FrameRequestCallback): number {
            const id = window.requestAnimationFrame(callback);
            this.$onCleanup(() => cancelAnimationFrame(id));
            return id;
        }
    }
});